import {Pipe, PipeTransform} from '@angular/core';
/**
 * Created by Rumyantsev Daniil on 03.05.2018.
 */
@Pipe({name: 'monthDiff'})
export class MonthDifferencePipe implements PipeTransform {

  transform(futureDateInMillis: Date): number {

    // console.log("future date: ", futureDateInMillis);
    if(futureDateInMillis == null) {
      return null;
    }

    const futureDate = new Date(futureDateInMillis);
    const currentDate = new Date();
    const diff = futureDate.getMonth() - currentDate.getMonth()
                  + (12 * (futureDate.getFullYear() - currentDate.getFullYear()));

    if(isNaN(diff)) return null;

    return diff;
  }

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/pipe/month-difference.pipe.ts